"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIDialogHeaderImage;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var setImageOffset = function setImageOffset(_ref) {
  var offsetBottom = _ref.offsetBottom,
      offsetTop = _ref.offsetTop;
  return {
    marginBottom: offsetBottom,
    marginTop: offsetTop * -1
  };
};

function UIDialogHeaderImage(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      offsetBottom = _ref2.offsetBottom,
      offsetTop = _ref2.offsetTop,
      style = _ref2.style,
      rest = (0, _objectWithoutProperties2.default)(_ref2, ["children", "className", "offsetBottom", "offsetTop", "style"]);
  return _react.default.createElement("div", (0, _extends2.default)({}, rest, {
    className: (0, _classNames.default)('private-modal__header-image', className),
    style: (0, _extends2.default)({}, setImageOffset({
      offsetBottom: offsetBottom,
      offsetTop: offsetTop
    }), style)
  }), children);
}

UIDialogHeaderImage.propTypes = {
  children: _react.PropTypes.node,
  offsetBottom: _react.PropTypes.number,
  offsetTop: _react.PropTypes.number
};
UIDialogHeaderImage.displayName = 'UIDialogHeaderImage';
module.exports = exports.default;